(() => {
  if (window.amyFeaturedEventInitialized) return;
  window.amyFeaturedEventInitialized = true;
  let expiryTimer;
  let noticeTimer;
  let opener;

  const runtime = () => document.querySelector('[data-amy-event-runtime]');
  const dialog = () => document.getElementById('amy-event-dialog');
  const storageKey = () => `amy-featured-event-dismissed:${runtime()?.dataset.eventKey}`;
  const expired = () => {
    const value = runtime()?.dataset.expires;
    return value && Number.isFinite(Date.parse(value)) && Date.now() >= Date.parse(value);
  };
  const expire = () => {
    document.querySelectorAll('[data-amy-event-surface], [data-amy-event-notice]').forEach(el => { el.hidden = true; });
    if (dialog()?.open) dialog().close();
  };
  const init = () => {
    clearTimeout(expiryTimer);
    clearTimeout(noticeTimer);
    if (!runtime()) return;
    if (expired()) { expire(); return; }
    const remaining = Date.parse(runtime().dataset.expires) - Date.now();
    if (Number.isFinite(remaining) && remaining > 0) expiryTimer = setTimeout(init, Math.min(remaining, 2147483647));
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(storageKey()) === 'true'; } catch {}
    if (!dismissed || runtime().dataset.designMode === 'true') {
      noticeTimer = setTimeout(() => {
        const notice = document.querySelector('[data-amy-event-notice]');
        if (notice && !expired()) notice.hidden = false;
      }, 1800);
    }
  };

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-amy-event-open]');
    if (open) {
      const modal = dialog();
      if (!modal || typeof modal.showModal !== 'function') return;
      event.preventDefault();
      if (expired()) { expire(); return; }
      opener = open;
      if (!modal.open) modal.showModal();
      return;
    }
    if (event.target.closest('[data-amy-event-dismiss]')) {
      const notice = document.querySelector('[data-amy-event-notice]');
      if (notice) notice.hidden = true;
      try { sessionStorage.setItem(storageKey(), 'true'); } catch {}
    }
    if (event.target.closest('[data-amy-event-close]')) dialog()?.close();
    if (event.target === dialog()) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.id === 'amy-event-dialog' && opener?.isConnected) opener.focus({ preventScroll: true });
  }, true);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && expired()) expire(); });
  init();
})();
